module.exports = __webpack_public_path__ + "img/bul_component_product.c06e5430.svg";